import React from 'react'

export const SVG_FACEBOOK = (
  <svg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
    <path d='M12.026 6.81004C12.026 7.56606 12.026 10.9405 12.026 10.9405H9V15.9911H12.026V31H18.2421V15.9916H22.4134C22.4134 15.9916 22.8041 13.5698 22.9934 10.9218C22.4505 10.9218 18.2656 10.9218 18.2656 10.9218C18.2656 10.9218 18.2656 7.98351 18.2656 7.46848C18.2656 6.95233 18.9434 6.25805 19.6132 6.25805C20.2818 6.25805 21.693 6.25805 23 6.25805C23 5.57039 23 3.19438 23 1C21.2552 1 19.2701 1 18.3952 1C11.8724 0.999651 12.026 6.05536 12.026 6.81004Z' />
  </svg>
)
